import httpClient from "../../../shared/api/httpClient";

// Painel administrativo (TSK-99): gestão de CONTAS (users), nunca de dados financeiros
// de outro médico — não existe (e não deve existir) nenhuma chamada aqui para
// vínculos/plantões/perfis de outro usuário. A visão geral (issue #19) recebe só a
// contagem de vínculos e plantões por médico, nunca valores.
export const adminApi = {
  getOverview: () => httpClient.get("/api/v1/admin/overview").then((r) => r.data.dados),

  listUsers: () => httpClient.get("/api/v1/admin/users").then((r) => r.data.dados ?? []),

  // Cadastro pelo painel: o admin nunca define senha. Devolve { user, link, expires_at,
  // invite_email_sent } — o link (24h, uso único) é o que o médico usa para escolher a senha.
  createAccount: ({ email, fullName, role }) =>
    httpClient.post("/api/v1/admin/users", { email, full_name: fullName, role }).then((r) => r.data.dados),

  // Detalhe da conta: dados da conta e só as CONTAGENS de vínculos e plantões.
  getUser: (id) => httpClient.get(`/api/v1/admin/users/${id}`).then((r) => r.data.dados),

  verifyUserEmail: (id) => httpClient.post(`/api/v1/admin/users/${id}/verify-email`).then((r) => r.data.dados),

  resendVerificationEmail: (id) =>
    httpClient.post(`/api/v1/admin/users/${id}/resend-verification`).then((r) => r.data.dados),

  // { link, expires_at } — o admin copia e manda ao médico; funciona sem SMTP.
  createPasswordResetLink: (id) =>
    httpClient.post(`/api/v1/admin/users/${id}/password-reset-link`).then((r) => r.data.dados),

  // Só superadmin (o backend recusa com 403 para admin comum).
  updateUserRole: (id, role) =>
    httpClient.patch(`/api/v1/admin/users/${id}/role`, { role }).then((r) => r.data.dados),

  updateUserStatus: (id, ativo) =>
    httpClient.patch(`/api/v1/admin/users/${id}/status`, { ativo }).then((r) => r.data.dados),

  // Libera/encerra acesso (TSK-81): último dia do trial e último dia pago, ambos
  // "aaaa-mm-dd" (horário de Brasília). assinaturaAte vazio remove a assinatura.
  updateUserAccess: (id, { trialAte, assinaturaAte }) =>
    httpClient
      .patch(`/api/v1/admin/users/${id}/access`, {
        trial_ate: trialAte,
        assinatura_ate: assinaturaAte,
      })
      .then((r) => r.data.dados),

  // Feedbacks enviados pelo botão flutuante (issue #8) — os 200 mais recentes primeiro.
  listFeedbacks: () => httpClient.get("/api/v1/admin/feedbacks").then((r) => r.data.dados ?? []),

  // Triagem: done=true marca o feedback como tratado, false reabre. Devolve { id, done_at }.
  setFeedbackDone: (id, done) =>
    httpClient.patch(`/api/v1/admin/feedbacks/${id}`, { done }).then((r) => r.data.dados),
};
